<template>
  <div
    @click="$emit('toggle', time.id)"
    class="pa-1 mt-1"
    style="border: 1px solid lightgrey; border-radius: 4px; cursor: pointer;"
  >
    <div class="d-flex justify-space-between">
      <div class="d-flex align-center">
        <div>
          <v-icon v-if="opened">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </div>
        <div class="d-flex align-center pl-2">
          {{ time.player_name.slice(0, 20) }}
        </div>
      </div>
      <div class="d-flex align-center">
        <v-chip color="primary" v-if="time.distance_from_base && ['msu', 'nsu'].includes(currentLeagueName)" v-tooltip="'Etäisyys pesästä'" class="ml-1" small>{{ time.distance_from_base }} m</v-chip>
        <v-chip color="primary" v-if="time.throw_speed" v-tooltip="'Etäisyys pesästä'" class="ml-1" small>{{ time.throw_speed.toFixed(0) }} km/h</v-chip>
        <div class="d-flex flex-column">
          <div v-if="['msu'].includes(currentLeagueName)" class="ml-1 d-flex justify-center" style="font-size: 10px;" x-small>{{ time.mark_type }}</div>
          <div class="ml-1 d-flex justify-center" style="font-size: 10px;" x-small>{{ mapped_bases[time.base] }}</div>
        </div>
        <v-chip class="ml-2" outlined label color="primary">
          {{ s2p(time.total_time) }}
        </v-chip>
        <v-icon
          v-if="user.tiimio_admin"
          @click.stop="$emit('delete', time.id)"
          size="12"
        >
          mdi-close
        </v-icon>
      </div>
    </div>
    <v-expand-transition>
      <div @click.stop v-show="opened" class="d-flex-row" style="cursor: default;">
        <div class="mt-3 mb-2">
          <div
            v-for="(ke, i) in Object.keys(important_keys).filter(k => time[k] || time[k] === 0)"
            :key="ke"
            style="cursor: pointer;"
            @click="pause(); seek(time.first_time_video_time + time[ke])"
          >
            <v-divider v-if="i != 0"></v-divider>
            <div class="d-flex px-2 justify-space-between align-items-center">
              <div>{{ important_keys[ke] }}</div>
              <div>
                {{ s2p(time[ke]) }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="time.conc_ball_at_base_time"
          class="d-flex justify-space-between align-center mt-2 px-2"
        >
          <div>
            Pallo pesässä
          </div>
          <v-chip label>
            {{ s2p(time.conc_ball_at_base_time)}}
            <!-- <span class="ml-2"
              :style="{
                color: time.conc_ball_at_base_time - time.runner_at_base_time < 0 ? 'red' : 'green'
              }"
              v-if="time.runner_at_base_time">
              {{ s2p(time.conc_ball_at_base_time - time.runner_at_base_time) }}
            </span> -->
          </v-chip>
        </div>
        <div
          v-if="time.conc_runner_at_base_time"
          class="d-flex justify-space-between align-center mt-2 px-2"
        >
          <div>
            Eteneminen
          </div>
          <v-chip label>
            {{ s2p(time.conc_runner_at_base_time)}}
            <!-- <span class="ml-2"
              :style="{
                color: time.conc_runner_at_base_time - time.ball_at_base_time < 0 ? 'red' : 'green'
              }"
              v-if="time.ball_at_base_time">
              {{ s2p(time.conc_runner_at_base_time - time.ball_at_base_time) }}
            </span> -->
          </v-chip>
        </div>
        <div
          v-if="time.throw_speed"
          class="d-flex justify-space-between align-center mt-2 px-2"
        >
          <div>
            Heiton kovuus
          </div>
          <v-chip label>
            {{ time.throw_speed.toFixed(0) }} km/h
          </v-chip>
        </div>
        <div class="d-flex justify-center align-center">
          <v-btn v-no-focus v-tooltip="'Toista alusta'" @click="$emit('toStart')" small text fab>
            <v-icon>mdi-sync</v-icon>
          </v-btn>
          <v-chip class="ml-2" label large>
            {{ s2p(dur) }}
          </v-chip>
          <v-chip class="ml-2" label large color="primary">
            {{ s2p(time.total_time) }}
          </v-chip>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import time from '@/utils/player/time'
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [time],
  props: ['time', 'opened'],
  data: () => ({
    mapped_bases: {
      0: 'K-1',
      1: '1-2',
      2: '2-3',
      3: '3-K',
    },
    important_keys: {
      'syotto_time': 'Syöttö nousee',
      'hit_time': 'Lyönti osuu mailaan',
      'bat_drops_time': 'Maila laskee',
      'lahto_time': 'Etenijä lähtee',
      'runner_at_base_time': 'Etenijä pesässä',
      'possession_time': 'Pallo hallussa',
      'throw_time': 'Heitto lähtee',
      'ball_at_base_time': 'Pallo pesässä'
    }
  }),
  computed: {
    ...mapGetters('player', [
      'accurateCurrentTime'
    ]),
    ...mapGetters('user', [
      'user',
      'currentLeagueName'
    ]),
    dur() {
      if(!this.opened) return 0
      if(!this.time.first_time_video_time) return 0

      const gone = this.accurateCurrentTime - this.time.first_time_video_time
      return Math.min(gone, this.time.total_time)
    }
  },
  methods: {
    ...mapActions('player', [
      'seek',
      'pause'
    ]),
    s2p(time) {
      return this.secondsToPrettyTimer(time)
    },
    open() {
      this.opened = true
    }
  }
}
</script>